export var ERCStandard;
(function (ERCStandard) {
    ERCStandard["ERC721"] = "ERC721";
    ERCStandard["ERC1155"] = "ERC1155";
    ERCStandard["POAP"] = "POAP";
})(ERCStandard || (ERCStandard = {}));
export var Namespace;
(function (Namespace) {
    Namespace["EIP155"] = "eip155";
    Namespace["SOLANA"] = "solana";
    Namespace["POLYGON"] = "polygon";
    Namespace["XDAI"] = "xdai";
    Namespace["ETHEREUM"] = "ethereum";
})(Namespace || (Namespace = {}));
export var Chain;
(function (Chain) {
    Chain["POLYGON"] = "polygon";
    Chain["XDAI"] = "xdai";
    Chain["ETHEREUM"] = "ethereum";
})(Chain || (Chain = {}));
